
    <!--
 * 横版-首页
 * @LastEditTime: Fri Apr 04 2025 19:11:26 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_LVEH374"  :style="`background: linear-gradient(to bottom, transparent 50%, ${ pageData.bgColor });
}`" :class="[`normal`,`u_c_LVEH374`]" ><div id="u_c_LJ1N19"  :class="[`normal`,`u_c_LJ1N19`]" ><a id="u_c_2506377" href="javascript:;" :style="`background-color:${ pageData.btnColor }`" :class="[`normal btn-light  btn-text`,`u_c_2506377`]" @click="u_c_2506377_event_8QY427($event)">{{`${ langData.infoBtn }`}}</a><a id="u_c_1KPZ375" href="javascript:;" :style="`background-color:${ pageData.btnColor }`" v-if="pageData.isLogin" :class="[`normal btn-light btn-text`,`u_c_1KPZ375`]" @click="u_c_1KPZ375_event_8QY427($event)">{{`${ langData.myPackage }`}}</a></div><div id="u_c_SR9T379"  :class="[`normal`,`u_c_SR9T379`]" ></div><div id="u_c_20IT380"  :class="[`normal title`,`u_c_20IT380`]" ><h1 id="u_c_N97U381"  v-if="compData.mainTitleBg" :style="`background-image:url(${ compData.mainTitleBg })`" :class="[`normal`,`u_c_N97U381`]" ></h1><h1 id="u_c_W7KN382"  v-if="!compData.mainTitleBg" :class="[`normal`,`u_c_W7KN382`]" ><div id="u_c_R6MA20"  v-html="compData.title" :style="`text-shadow: 2px 5px 10px ${ compData.titleShadowColor }`" :class="[`normal title-text`,`u_c_R6MA20`]" ></div><div id="u_c_T36D383"  v-html="compData.title" :style="`display:${ pageData.isEdit ? 'block' : 'inline' };background-image:linear-gradient(to right, ${ pageData.titleColor1 },${ pageData.titleColor2 })`" :class="[`normal title-text`,`u_c_T36D383`]" ></div></h1></div><div id="u_c_4H98385"  :style="`background-color:${ pageData.btnColor }`" :class="[`normal btn-text`,`u_c_4H98385`]" ><div id="u_c_ZKHU386"  v-html="compData.eventTime" :class="[`normal activity-time`,`u_c_ZKHU386`]" ></div></div><div id="u_c_1BMN387"  v-show="pageData.isEdit ? !compData.preLogin : !pageData.isLogin" :style="`background-color:${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal`,`u_c_1BMN387`]" ><div id="u_c_XJCC388"  :class="[`normal login-box`,`u_c_XJCC388`]" ><div id="u_c_UD9F389"  :class="[`normal txt`,`u_c_UD9F389`]" >{{`${ langData.pleaseLogin }`}}</div><a id="u_c_NK5B391" href="javascript:;" :class="[`normal txt btn login-btn`,`u_c_NK5B391`]" @click="u_c_NK5B391_event_Q72S64($event)">{{`[${ langData.login }]`}}</a></div></div><div id="u_c_2X8M21"  v-show="pageData.isEdit ? compData.preLogin : pageData.isLogin" :style="`background-color:${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal`,`u_c_2X8M21`]" ><div id="u_c_38P727"  :class="[`normal`,`u_c_38P727`]" ><div id="u_c_YRTC30"  v-if="pageData.loginAccount" :class="[`normal txt btn user-server-role`,`u_c_YRTC30`]" >{{`${ pageData.loginAccount }`}}</div><div id="u_c_EYHA28"  v-show="pageData.isBind && !pageData.isBrandType" :class="[`normal txt btn user-server-role`,`u_c_EYHA28`]" >{{`${ pageData.serverName }-${ pageData.roleName }`}}</div><div id="u_c_876E32"  :class="[`normal`,`u_c_876E32`]" ><a id="u_c_8IE633" href="javascript:;" v-show="!pageData.isBind && !pageData.isBrandType" :class="[`normal txt btn  bind-btn`,`u_c_8IE633`]" @click="u_c_8IE633_event_Z75334($event)">{{`[${ langData.bindTitle }]`}}</a><a id="u_c_IXLU35" href="javascript:;" v-show="pageData.isBind && pageData.canReBind && !pageData.isBrandType" :class="[`normal txt btn  unbind-btn`,`u_c_IXLU35`]" @click="u_c_IXLU35_event_Z75334($event)">{{`[${ langData.changRole }]`}}</a><a id="u_c_59EZ37" href="javascript:;" :class="[`normal txt btn logout-btn`,`u_c_59EZ37`]" @click="u_c_59EZ37_event_Q72S64($event)">{{`[${ langData.logout }]`}}</a></div></div></div><div id="u_c_M92F19"  :class="[`normal`,`u_c_M92F19`]" ><div id="u_c_QJJA137"  v-show="pageData.previewPopup == 'info' || pageData.infoPopupState" :class="[`normal popup info-popup `,`u_c_QJJA137`]" @click="u_c_QJJA137_event_TETB35($event)"><div id="u_c_Q2K8138"  :style="`background-color: ${ pageData.bgColor };border-color:${ pageData.borderColor }`" :class="[`normal popup-content-big`,`u_c_Q2K8138`]" @click="u_c_Q2K8138_event_U82518($event)"><div id="u_c_G1D7139"  :class="[`normal popup-title popup-title-color`,`u_c_G1D7139`]" >{{`${ langData.infoBtn }`}}</div><div id="u_c_RQU1141"  v-html="compData.infoContent" :class="[`normal txt-size txt-color info-popup-content`,`u_c_RQU1141`]" ></div><a id="u_c_JY73142" href="javascript:;" :class="[`normal popup-close info-popup-close`,`u_c_JY73142`]" @click="u_c_JY73142_event_DMX517($event)"></a></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const curRouterCompMap = inject("curRouterCompMap",{});
    const COMP_DATA_LANG = {"default":{"eventTime":`活动时间：2023年2月28日 ～2023年3月3日23:59`,"title":`37GAMES大抽奖
换行效果`,"mainTitleBg":``,"preLogin":0,"infoContent":``,"titleShadowColor":`#000000`},"en-US":{"eventTime":`Event Time: 2025/4/3 00:00 - 2025/5/3 00:00 (UTC+4)`,"title":`Champion's Return`,"mainTitleBg":``,"preLogin":0,"infoContent":`Event Time Zone:utc+4
1.Rules

[Complete Quests, Claim Rewards]
Complete designated Quests during the Event to claim Rewards
Quest details and participation restrictions are subject to the page display

[Login Rewards, Continuous Surprises]
(1)Log in to the PC client to claim benefits
Log in to the PC client consecutively for the required number of days during the event period to claim corresponding rewards.
Tiers: Consecutive login for 1、2、3、4、5、6、7 days. 
Rewards for each tier can only be claimed once per account.

2.Claiming Rewards
(1)Item Rewards: Item rewards will be sent automatically to the Character connected to in the page after claiming. Please check your in-game Mail (Please be patient in case of system delays).
(2)Official Coupon Rewards: Coupon rewards will be sent automatically to the Official Purchase Center - My Coupons after claiming. You can check them in the Official Purchase Center
(3)Unclaimed rewards can be claimed within 7 days after the event ends and will expire after 7 days`,"titleShadowColor":`#000000`},"th-TH":{"eventTime":`เวลากิจกรรม: 2025/4/3 00:00 - 2025/5/3 00:00 (UTC+4)`,"title":`ผู้กล้าหวนคืน`,"mainTitleBg":``,"preLogin":0,"infoContent":`โซนเวลากิจกรรม : utc+4
1.คำอธิบายกติกา

[ทำเควสรับรางวัล]
ช่วงกิจกรรม เคลียร์เควสที่กำหนด จะได้รับรางวัล
ตั้งค่าเควสและเงื่อนไขเข้าร่วมโปรดยึดตามหน้าแสดง

[แพ็กใหญ่ล็อกอิน เซอร์ไพรส์ไม่อั้น]
（1）ล็อกอิน PC รับโบนัส
ช่วงกิจกรรม ล็อกอิน PC ต่อเนื่องถึงจำนวนวันที่กำหนด จะได้รับรางวัลสอดคล้อง;
ตั้งค่าเรท : ล็อกอินต่อเนื่อง 1、2、3、4、5、6、7 วัน
รางวัลแต่ละเรท แต่ละบัญชีจะสามารถรับเพียง 1 ครั้ง;

2.คำอธิบายรับรางวัล
（1）รางวัลไอเทม : หลังรับรางวัลไอเทม จะส่งสู่ภายในตัวละครที่ผูกมัดในหน้าหวนคืนอัตโนมัติ โปรดไปตรวจรับในอีเมลเกม(หากระบบล่าช้า โปรดอดใจรอ)
（2）รางวัลคูปองโปรฯทางการ : หลังรับรางวัลคูปองโปรฯ จะส่งสู่ภายในศูนย์เติมเงินทางการ-คูปองโปรฯของฉันอัตโนมัติ สามารถไปดูในศูนย์เติมเงินทางการ
（3）รางวัลที่ไม่ได้รับสามารถรับต่อหลังสิ้นสุดกิจกรรมภายใน 7 วัน หมดอายุหลัง 7 วัน;`,"titleShadowColor":`#000000`},"ru-RU":{"eventTime":`Время события: 2025/4/3 00:00 - 2025/5/3 00:00 (UTC+4)`,"title":`Возвращение чемпиона`,"mainTitleBg":``,"preLogin":0,"infoContent":`Часовой пояс события:utc+4
1.Правила

[Выполняйте задания, получайте награды]
Выполняйте задания во время события, чтобы получать награды
Подробности заданий и ограничения на участие указаны на странице события

[Награды за вход, постоянные призы]
(1) Войдите в систему на ПК, чтобы получить бонусы
Входите в систему на ПК в течение необходимого количества дней в течение события, чтобы получить соответствующие награды.
Уровни: Последовательно входите в систему в течение 1、2、3、4、5、6、7 дн. 

Награды за каждый уровень можно получить только один раз на каждый аккаунт.

2.Получение наград
(1) Предметные награды: после сбора будут автоматически отправлены персонажу, привязанному к странице события. Проверяйте свою игровую почту (могут быть системные задержки).
(2) Купоны в награду: после сбора будут автоматически отправлены в Официальный центр покупок - «Мои купоны». Вы можете проверить их в Официальном центре покупок
(3) Забытые награды можно получить в течение 7 дн. после окончания события, срок их действия истечет через 7 дн.`,"titleShadowColor":`#000000`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '首页';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})

const curPlatform = pagePlatform;

const canClickChange = ref(true);

compData.preLogin = 0;
      // 活动规则的click事件
      const u_c_2506377_event_8QY427= async (e)=>{
        try {pageData.infoPopupState = true;} catch (error) {console.log(error)}
      };
      // 奖品按钮的click事件
      const u_c_1KPZ375_event_8QY427= async (e)=>{
        try {pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 登入按钮的click事件
      const u_c_NK5B391_event_Q72S64= async (e)=>{
        try {checkIsLogin()} catch (error) {console.log(error)}
      };
      // 绑定按钮的click事件
      const u_c_8IE633_event_Z75334= async (e)=>{
        try {if (!checkIsLogin()) return
pageData.bindPopupState = true;} catch (error) {console.log(error)}
      };
      // 解绑按钮的click事件
      const u_c_IXLU35_event_Z75334= async (e)=>{
        try {if (!canClickChange.value) return;

canClickChange.value = false;

let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'resetUserBind'))
canClickChange.value = true;

if (res.result != 1) {
  showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  return;
}

pageData.isBind = false;
pageData.roleName = "";
pageData.serverName = "";} catch (error) {console.log(error)}
      };
      // 登出按钮的click事件
      const u_c_59EZ37_event_Q72S64= async (e)=>{
        try {let res = await request.getJSON(utils.getLogoutApi(pagePlatform))
if (res.result == 1) {
  // 如果是品牌活动，登出要清掉gameId，防止跳转到游戏登录页
  if (pageData.isBrandType) {
    const url = new URL(window.location.href);
    // 删除gameId参数
    url.searchParams.delete('gameId');
    // 重新加载页面
    window.location.href = url.toString();
  } else {
    window.location.reload()
  }

}} catch (error) {console.log(error)}
      };
      // 活动规则弹窗的click事件
      const u_c_QJJA137_event_TETB35= async (e)=>{
        try {pageData.infoPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_Q2K8138_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_JY73142_event_DMX517= async (e)=>{
        try {pageData.infoPopupState = false} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_LVEH374.normal{
position:relative;
width:100.00vw;
height:56.25vw;
margin:auto;
font-size:0;
box-sizing:border-box;
overflow:hidden;

}

.u_c_LVEH374.normal .txt{
font-size:1.82vw;
color:#ffffff;

}
}.default{
.u_c_LJ1N19.normal{
position:absolute;
top:2.50vw;
left:25.31vw;
display:flex;

}
}.default{
.u_c_2506377.normal{
position:relative;
min-width:3.44vw;
height:3.70vw;
display:flex;
align-items:center;
font-size:1.67vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;
border-radius:1.20vw;
padding:0 2.34vw;
z-index:5;
margin-right:1.56vw;

}
}.default{
.u_c_1KPZ375.normal{
position:relative;
min-width:3.44vw;
height:3.70vw;
display:flex;
align-items:center;
font-size:1.67vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;
border-radius:1.20vw;
padding:0 2.34vw;
z-index:5;

}
}.default{
.u_c_SR9T379.normal{
position:absolute;
width:15.26vw;
height:4.43vw;
top:2.03vw;
left:10.21vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1736134225256-81.png);
background-size:contain;

}
}.default{
.u_c_20IT380.normal{
position:absolute;
display:flex;
justify-content:center;
top:39.58vw;
left:50%;
transform:translateX(-50%);
max-width:65.36vw;

}
}.default{
.u_c_N97U381.normal{
position:relative;
top:0;
width:8.13vw;
height:2.66vw;
left:0;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.default{
.u_c_W7KN382.normal{
position:relative;
margin:0;
line-height:1.2;
width:65.36vw;
white-space:pre-wrap;
text-align:center;

}

.u_c_W7KN382.normal .title-text{
font-size:4.17vw;
font-weight:bold;

}
}.default{
.u_c_R6MA20.normal{
position:absolute;
z-index:-1;
left:0;
width:100%;
font-size:3.13vw;

}
}.default{
.u_c_T36D383.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
color:transparent;

}
}.default{
.u_c_4H98385.normal{
position:absolute;
width:fit-content;
line-height:1.0;
font-size:1.56vw;
color:#ffffff;
white-space:nowrap;
text-align:center;
font-weight:normal;
left:50%;
padding:1.04vw 1.04vw;
border-radius:0.73vw;
top:45.57vw;
transform:translateX(-50%);
max-width:65.36vw;
height:auto;

}
}.default{
.u_c_ZKHU386.normal{
position:relative;

}
}.default{
.u_c_1BMN387.normal{
position:absolute;
font-size:0;
box-sizing:border-box;
text-align:center;
background:no-repeat center;
background-size:contain;
width:36.46vw;
display:flex;
justify-content:center;
align-items:center;
border:solid 3px #1f4538;
border-radius:1.20vw;
padding:1.04vw 1.56vw;
left:50%;
transform:translateX(-50%);
top:50.26vw;

}

.u_c_1BMN387.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_1BMN387.normal .btn{
margin:auto 0.52vw;

}
}.default{
.u_c_XJCC388.normal{
position:relative;

}
}.default{
.u_c_UD9F389.normal{
position:relative;

}
}.default{
.u_c_NK5B391.normal{
position:relative;

}
}.default{
.u_c_2X8M21.normal{
position:absolute;
font-size:0;
box-sizing:border-box;
width:65.36vw;
height:fit-content;
border-radius:1.20vw;
padding:1.04vw 1.56vw;
box-sizing:border-box;
left:50%;
transform:translateX(-50%);
top:50.26vw;

}

.u_c_2X8M21.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_2X8M21.normal .btn{
margin:auto 0.52vw;

}
}.default{
.u_c_38P727.normal{
position:relative;
display:flex;
flex-flow:nowrap;
justify-content:center;

}
}.default{
.u_c_YRTC30.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_EYHA28.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_876E32.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_8IE633.normal{
position:relative;

}
}.default{
.u_c_IXLU35.normal{
position:relative;

}
}.default{
.u_c_59EZ37.normal{
position:relative;

}
}.default{.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}}.default{
.u_c_QJJA137.normal{
position:relative;

}
}.default{
.u_c_Q2K8138.normal{
position:relative;
width:52.08vw !important;
height:5.21vw;

}
}.default{
.u_c_G1D7139.normal{
position:relative;
margin-top:1.20vw;

}
}.default{
.u_c_RQU1141.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_JY73142.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.en-US{
.u_c_LVEH374.normal{
position:relative;
width:100.00vw;
height:56.25vw;
margin:auto;
font-size:0;
box-sizing:border-box;
overflow:hidden;

}

.u_c_LVEH374.normal .txt{
font-size:1.82vw;
color:#ffffff;

}
}.en-US{
.u_c_LJ1N19.normal{
position:absolute;
top:2.50vw;
left:25.31vw;
display:flex;

}
}.en-US{
.u_c_2506377.normal{
position:relative;
min-width:3.44vw;
height:3.70vw;
display:flex;
align-items:center;
font-size:1.67vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;
border-radius:1.20vw;
padding:0 2.34vw;
z-index:5;
margin-right:1.56vw;

}
}.en-US{
.u_c_1KPZ375.normal{
position:relative;
min-width:3.44vw;
height:3.70vw;
display:flex;
align-items:center;
font-size:1.67vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;
border-radius:1.20vw;
padding:0 2.34vw;
z-index:5;

}
}.en-US{
.u_c_SR9T379.normal{
position:absolute;
width:15.26vw;
height:4.43vw;
top:2.03vw;
left:10.21vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887949963-77.png);
background-size:contain;

}
}.en-US{
.u_c_20IT380.normal{
position:absolute;
display:flex;
justify-content:center;
top:39.58vw;
left:50%;
transform:translateX(-50%);
max-width:65.36vw;

}
}.en-US{
.u_c_N97U381.normal{
position:relative;
top:0;
width:8.13vw;
height:2.66vw;
left:0;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.en-US{
.u_c_W7KN382.normal{
position:relative;
margin:0;
line-height:1.2;
width:65.36vw;
white-space:pre-wrap;
text-align:center;

}

.u_c_W7KN382.normal .title-text{
font-size:4.17vw;
font-weight:bold;

}
}.en-US{
.u_c_R6MA20.normal{
position:absolute;
z-index:-1;
left:0;
width:100%;
font-size:3.13vw;

}
}.en-US{
.u_c_T36D383.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
color:transparent;

}
}.en-US{
.u_c_4H98385.normal{
position:absolute;
width:fit-content;
line-height:1.0;
font-size:1.56vw;
color:#ffffff;
white-space:nowrap;
text-align:center;
font-weight:normal;
left:50%;
padding:1.04vw 1.04vw;
border-radius:0.73vw;
top:45.57vw;
transform:translateX(-50%);
max-width:65.36vw;
height:auto;

}
}.en-US{
.u_c_ZKHU386.normal{
position:relative;

}
}.en-US{
.u_c_1BMN387.normal{
position:absolute;
font-size:0;
box-sizing:border-box;
text-align:center;
background:no-repeat center;
background-size:contain;
width:36.46vw;
display:flex;
justify-content:center;
align-items:center;
border:solid 3px #1f4538;
border-radius:1.20vw;
padding:1.04vw 1.56vw;
left:50%;
transform:translateX(-50%);
top:50.26vw;

}

.u_c_1BMN387.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_1BMN387.normal .btn{
margin:auto 0.52vw;

}
}.en-US{
.u_c_XJCC388.normal{
position:relative;

}
}.en-US{
.u_c_UD9F389.normal{
position:relative;

}
}.en-US{
.u_c_NK5B391.normal{
position:relative;

}
}.en-US{
.u_c_2X8M21.normal{
position:absolute;
font-size:0;
box-sizing:border-box;
width:65.36vw;
height:fit-content;
border-radius:1.20vw;
padding:1.04vw 1.56vw;
box-sizing:border-box;
left:50%;
transform:translateX(-50%);
top:50.26vw;

}

.u_c_2X8M21.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_2X8M21.normal .btn{
margin:auto 0.52vw;

}
}.en-US{
.u_c_38P727.normal{
position:relative;
display:flex;
flex-flow:nowrap;
justify-content:center;

}
}.en-US{
.u_c_YRTC30.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_EYHA28.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_876E32.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_8IE633.normal{
position:relative;

}
}.en-US{
.u_c_IXLU35.normal{
position:relative;

}
}.en-US{
.u_c_59EZ37.normal{
position:relative;

}
}.en-US{.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}}.en-US{
.u_c_QJJA137.normal{
position:relative;

}
}.en-US{
.u_c_Q2K8138.normal{
position:relative;
width:52.08vw !important;
height:5.21vw;

}
}.en-US{
.u_c_G1D7139.normal{
position:relative;
margin-top:1.20vw;

}
}.en-US{
.u_c_RQU1141.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_JY73142.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.th-TH{
.u_c_LVEH374.normal{
position:relative;
width:100.00vw;
height:56.25vw;
margin:auto;
font-size:0;
box-sizing:border-box;
overflow:hidden;

}

.u_c_LVEH374.normal .txt{
font-size:1.82vw;
color:#ffffff;

}
}.th-TH{
.u_c_LJ1N19.normal{
position:absolute;
top:2.50vw;
left:25.31vw;
display:flex;

}
}.th-TH{
.u_c_2506377.normal{
position:relative;
min-width:3.44vw;
height:3.70vw;
display:flex;
align-items:center;
font-size:1.67vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;
border-radius:1.20vw;
padding:0 2.34vw;
z-index:5;
margin-right:1.56vw;

}
}.th-TH{
.u_c_1KPZ375.normal{
position:relative;
min-width:3.44vw;
height:3.70vw;
display:flex;
align-items:center;
font-size:1.67vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;
border-radius:1.20vw;
padding:0 2.34vw;
z-index:5;

}
}.th-TH{
.u_c_SR9T379.normal{
position:absolute;
width:15.26vw;
height:4.43vw;
top:2.03vw;
left:10.21vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887949963-77.png);
background-size:contain;

}
}.th-TH{
.u_c_20IT380.normal{
position:absolute;
display:flex;
justify-content:center;
top:39.58vw;
left:50%;
transform:translateX(-50%);
max-width:65.36vw;

}
}.th-TH{
.u_c_N97U381.normal{
position:relative;
top:0;
width:8.13vw;
height:2.66vw;
left:0;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.th-TH{
.u_c_W7KN382.normal{
position:relative;
margin:0;
line-height:1.2;
width:65.36vw;
white-space:pre-wrap;
text-align:center;

}

.u_c_W7KN382.normal .title-text{
font-size:4.17vw;
font-weight:bold;

}
}.th-TH{
.u_c_R6MA20.normal{
position:absolute;
z-index:-1;
left:0;
width:100%;
font-size:3.13vw;

}
}.th-TH{
.u_c_T36D383.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
color:transparent;

}
}.th-TH{
.u_c_4H98385.normal{
position:absolute;
width:fit-content;
line-height:1.0;
font-size:1.56vw;
color:#ffffff;
white-space:nowrap;
text-align:center;
font-weight:normal;
left:50%;
padding:1.04vw 1.04vw;
border-radius:0.73vw;
top:45.57vw;
transform:translateX(-50%);
max-width:65.36vw;
height:auto;

}
}.th-TH{
.u_c_ZKHU386.normal{
position:relative;

}
}.th-TH{
.u_c_1BMN387.normal{
position:absolute;
font-size:0;
box-sizing:border-box;
text-align:center;
background:no-repeat center;
background-size:contain;
width:36.46vw;
display:flex;
justify-content:center;
align-items:center;
border:solid 3px #1f4538;
border-radius:1.20vw;
padding:1.04vw 1.56vw;
left:50%;
transform:translateX(-50%);
top:50.26vw;

}

.u_c_1BMN387.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_1BMN387.normal .btn{
margin:auto 0.52vw;

}
}.th-TH{
.u_c_XJCC388.normal{
position:relative;

}
}.th-TH{
.u_c_UD9F389.normal{
position:relative;

}
}.th-TH{
.u_c_NK5B391.normal{
position:relative;

}
}.th-TH{
.u_c_2X8M21.normal{
position:absolute;
font-size:0;
box-sizing:border-box;
width:65.36vw;
height:fit-content;
border-radius:1.20vw;
padding:1.04vw 1.56vw;
box-sizing:border-box;
left:50%;
transform:translateX(-50%);
top:50.26vw;

}

.u_c_2X8M21.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_2X8M21.normal .btn{
margin:auto 0.52vw;

}
}.th-TH{
.u_c_38P727.normal{
position:relative;
display:flex;
flex-flow:nowrap;
justify-content:center;

}
}.th-TH{
.u_c_YRTC30.normal{
position:relative;
white-space:nowrap;

}
}.th-TH{
.u_c_EYHA28.normal{
position:relative;
white-space:nowrap;

}
}.th-TH{
.u_c_876E32.normal{
position:relative;
white-space:nowrap;

}
}.th-TH{
.u_c_8IE633.normal{
position:relative;

}
}.th-TH{
.u_c_IXLU35.normal{
position:relative;

}
}.th-TH{
.u_c_59EZ37.normal{
position:relative;

}
}.th-TH{.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}}.th-TH{
.u_c_QJJA137.normal{
position:relative;

}
}.th-TH{
.u_c_Q2K8138.normal{
position:relative;
width:52.08vw !important;
height:5.21vw;

}
}.th-TH{
.u_c_G1D7139.normal{
position:relative;
margin-top:1.20vw;

}
}.th-TH{
.u_c_RQU1141.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.th-TH{
.u_c_JY73142.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}.ru-RU{
.u_c_LVEH374.normal{
position:relative;
width:100.00vw;
height:56.25vw;
margin:auto;
font-size:0;
box-sizing:border-box;
overflow:hidden;

}

.u_c_LVEH374.normal .txt{
font-size:1.82vw;
color:#ffffff;

}
}.ru-RU{
.u_c_LJ1N19.normal{
position:absolute;
top:2.50vw;
left:25.31vw;
display:flex;

}
}.ru-RU{
.u_c_2506377.normal{
position:relative;
min-width:3.44vw;
height:3.70vw;
display:flex;
align-items:center;
font-size:1.67vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;
border-radius:1.20vw;
padding:0 2.34vw;
z-index:5;
margin-right:1.56vw;

}
}.ru-RU{
.u_c_1KPZ375.normal{
position:relative;
min-width:3.44vw;
height:3.70vw;
display:flex;
align-items:center;
font-size:1.67vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;
border-radius:1.20vw;
padding:0 2.34vw;
z-index:5;

}
}.ru-RU{
.u_c_SR9T379.normal{
position:absolute;
width:15.26vw;
height:4.43vw;
top:2.03vw;
left:10.21vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742887949963-77.png);
background-size:contain;

}
}.ru-RU{
.u_c_20IT380.normal{
position:absolute;
display:flex;
justify-content:center;
top:39.58vw;
left:50%;
transform:translateX(-50%);
max-width:65.36vw;

}
}.ru-RU{
.u_c_N97U381.normal{
position:relative;
top:0;
width:8.13vw;
height:2.66vw;
left:0;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.ru-RU{
.u_c_W7KN382.normal{
position:relative;
margin:0;
line-height:1.2;
width:65.36vw;
white-space:pre-wrap;
text-align:center;

}

.u_c_W7KN382.normal .title-text{
font-size:4.17vw;
font-weight:bold;

}
}.ru-RU{
.u_c_R6MA20.normal{
position:absolute;
z-index:-1;
left:0;
width:100%;
font-size:3.13vw;

}
}.ru-RU{
.u_c_T36D383.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
color:transparent;

}
}.ru-RU{
.u_c_4H98385.normal{
position:absolute;
width:fit-content;
line-height:1.0;
font-size:1.56vw;
color:#ffffff;
white-space:nowrap;
text-align:center;
font-weight:normal;
left:50%;
padding:1.04vw 1.04vw;
border-radius:0.73vw;
top:45.57vw;
transform:translateX(-50%);
max-width:65.36vw;
height:auto;

}
}.ru-RU{
.u_c_ZKHU386.normal{
position:relative;

}
}.ru-RU{
.u_c_1BMN387.normal{
position:absolute;
font-size:0;
box-sizing:border-box;
text-align:center;
background:no-repeat center;
background-size:contain;
width:36.46vw;
display:flex;
justify-content:center;
align-items:center;
border:solid 3px #1f4538;
border-radius:1.20vw;
padding:1.04vw 1.56vw;
left:50%;
transform:translateX(-50%);
top:50.26vw;

}

.u_c_1BMN387.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_1BMN387.normal .btn{
margin:auto 0.52vw;

}
}.ru-RU{
.u_c_XJCC388.normal{
position:relative;

}
}.ru-RU{
.u_c_UD9F389.normal{
position:relative;

}
}.ru-RU{
.u_c_NK5B391.normal{
position:relative;

}
}.ru-RU{
.u_c_2X8M21.normal{
position:absolute;
font-size:0;
box-sizing:border-box;
width:65.36vw;
height:fit-content;
border-radius:1.20vw;
padding:1.04vw 1.56vw;
box-sizing:border-box;
left:50%;
transform:translateX(-50%);
top:50.26vw;

}

.u_c_2X8M21.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_2X8M21.normal .btn{
margin:auto 0.52vw;

}
}.ru-RU{
.u_c_38P727.normal{
position:relative;
display:flex;
flex-flow:nowrap;
justify-content:center;

}
}.ru-RU{
.u_c_YRTC30.normal{
position:relative;
white-space:nowrap;

}
}.ru-RU{
.u_c_EYHA28.normal{
position:relative;
white-space:nowrap;

}
}.ru-RU{
.u_c_876E32.normal{
position:relative;
white-space:nowrap;

}
}.ru-RU{
.u_c_8IE633.normal{
position:relative;

}
}.ru-RU{
.u_c_IXLU35.normal{
position:relative;

}
}.ru-RU{
.u_c_59EZ37.normal{
position:relative;

}
}.ru-RU{.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}}.ru-RU{
.u_c_QJJA137.normal{
position:relative;

}
}.ru-RU{
.u_c_Q2K8138.normal{
position:relative;
width:52.08vw !important;
height:5.21vw;

}
}.ru-RU{
.u_c_G1D7139.normal{
position:relative;
margin-top:1.20vw;

}
}.ru-RU{
.u_c_RQU1141.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.ru-RU{
.u_c_JY73142.normal{
position:absolute;
top:1.35vw;
right:1.15vw;

}
}
</style>
